var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDhl(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 143.5 20",
    height: 20,
    viewBox: "0 0 143.5 20",
    width: 143.5,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#d40511"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 18.5h17.4l-1 1.4h-16.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m143.5 19.9h-21.3l1.1-1.4h20.3v1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 15.9h19.4l-1.1 1.4h-18.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 13.3h21.4l-1.1 1.4h-20.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m143.5 17.3h-19.3l1.1-1.4h18.3v1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m127.2 13.3h16.3v1.4h-17.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.8 19.9 9.2-12.3h11.4c1.3 0 1.3.5.6 1.3-.6.8-1.7 2.3-2.3 3.1-.3.5-.9 1.2 1 1.2h15.3c-1.2 1.8-5.4 6.8-12.8 6.8-6-.1-22.4-.1-22.4-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.5 13.3-5 6.7h-13.1l5-6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.6 13.3-5 6.7h-13.2l5-6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94.9 13.3s-1 1.3-1.4 1.9c-1.7 2.2-.2 4.8 5.2 4.8h21.2l5-6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.3 0-4.6 6.1h25c1.3 0 1.3.5.6 1.3-.6.8-1.7 2.3-2.3 3.1-.3.4-.9 1.2 1 1.2h10.2s1.7-2.2 3-4.1c1.9-2.5.2-7.7-6.5-7.7-6 .1-26.4.1-26.4.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91.7 11.7h-32.2l8.8-11.7h13.2l-5 6.7h5.9l5-6.7h13.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.8 0-8.8 11.7h-14l8.8-11.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDhl);
export default __webpack_public_path__ + "static/media/dhl.6b72b44322187e172ea4e74918fa30f4.svg";
export { ForwardRef as ReactComponent };